import { publicAxios } from '@/lib/axios';
import { resolveSessionToken } from '@/lib/auth/resolveSessionToken';

/** Shared with partner SSO: look up the account before choosing a browser session. */
export async function lookupBrowserSessionToken(
  exchangedJwt: string | null,
  fallbackToken: string | null = null,
): Promise<string | null> {
  const lookupToken = exchangedJwt || fallbackToken;
  let isAdmin = false;
  if (lookupToken) {
    try {
      const me = await publicAxios.get('/api/users/me', {
        headers: { Authorization: `Bearer ${lookupToken}` },
      });
      isAdmin = me.data?.is_admin === true;
    } catch {
      isAdmin = false;
    }
  }
  return resolveSessionToken({ exchangedJwt, fallbackToken, isAdmin });
}
